import { render, staticRenderFns } from "./VehicleIssueSummary.vue?vue&type=template&id=b9020de4&scoped=true&"
import script from "./VehicleIssueSummary.vue?vue&type=script&lang=js&"
export * from "./VehicleIssueSummary.vue?vue&type=script&lang=js&"
import style0 from "./VehicleIssueSummary.vue?vue&type=style&index=0&id=b9020de4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9020de4",
  null
  
)

export default component.exports